import * as _ from 'lodash';
import { TableWrapperStickyHeader } from './styles';

interface IProps {
    list: any[]
}

const DashToDo = (props: IProps) => {
    let sorted = _.orderBy(props.list, x => x.registrationCount, ['desc']);

    return (
        <>
            <div style={{ marginBottom: 10 }}>Click a center alias to go to that center's DASH to-do list...</div>

            <div style={{ maxHeight: 400, overflowY: 'auto' }}>
                <TableWrapperStickyHeader>
                    <thead style={{ top: 'sticky' }}>
                        <tr>
                            <th>Center</th>
                            <th>Registration Count</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sorted.map(item =>
                            <tr key={'ctr-" + item.centerId'}>
                                <td><a href={'/center/' + item.centerId + '/profile/edit'} target='_blank'>{item.centerAlias}</a></td>
                                <td>{item.registrationCount}</td>
                            </tr>
                        )}
                    </tbody>
                </TableWrapperStickyHeader>
            </div>
        </>
    );
}

export default DashToDo;